import { getCsrfToken } from './csrf'

// Opening the menu the notifications are in is what "read" means, so this is
// the whole of the JavaScript the Notification Centre needs — the panels are
// <details> the server renders, and work without any of this.
//
// Two elements carry the marker: the desktop account menu, which shows the
// list inline, and the mobile menu's own notifications row. Opening the
// account menu to reach Log out therefore also marks them read, which is
// right — they were on screen.
//
// Degrades honestly: with JS off the menu still opens and still lists
// everything, the dot just doesn't clear. That's the right way round.
function markViewed(menu: HTMLDetailsElement) {
  // The dot is removed here rather than waiting for the response: the person
  // has demonstrably seen them, and a badge that lingers for a round trip
  // reads as the click not having worked.
  menu.querySelectorAll('[data-unread-dot]').forEach((dot) => dot.remove())

  void fetch('/notifications/viewed', {
    method: 'POST',
    headers: { 'X-CSRF-Token': getCsrfToken(), Accept: 'application/json' },
  })
}

function onToggle(event: Event) {
  const menu = (event.target as HTMLElement)?.closest<HTMLDetailsElement>(
    '[data-marks-notifications-viewed]'
  )
  if (!menu?.open) return
  // Only the first open of a given rendered menu needs to say anything —
  // opening and closing it twice on one page is not two readings.
  if (menu.dataset.marked) return

  menu.dataset.marked = 'true'
  markViewed(menu)
}

export function initNavNotifications() {
  // `toggle` doesn't bubble, so this listens in the capture phase rather than
  // binding per menu — which also means it keeps working after Turbo swaps in
  // a new body with new elements, with nothing to re-bind.
  document.addEventListener('toggle', onToggle, true)
}
